<template>
  <div class="list-item template-item">
    <v-list-item-avatar tile v-if="!isMobile">
      <v-icon size="30">mdi-playlist-check</v-icon>
    </v-list-item-avatar>
    <v-list-item-content>
      <div class="item-right">
        <div class="description justify-center">
          <div class="d-flex">
            <span class="font-weight-bold">{{ client.name }}</span>
          </div>
          <div class="status-wrapper">
            <span class="mr-1 mt-1 secondary-text">{{ totalCost }}</span>
          </div>
        </div>
      </div>
    </v-list-item-content>
  </div>
</template>

<script>
import { DEFAULT_CURRENCY } from "@/constants/common";

export default {
  props: {
    approvalChainTemplate: {
      type: Object,
      required: true
    }
  },
  computed: {
    currencyCode() {
      return this.approvalChainTemplate.currencyCode || DEFAULT_CURRENCY;
    },
    totalCost() {
      const currency = this.$options.filters.currency;
      return `${currency(
        this.approvalChainTemplate.totalCostLower,
        this.currencyCode
      )}-${currency(
        this.approvalChainTemplate.totalCostUpper,
        this.currencyCode
      )}`;
    },
    client() {
      return this.approvalChainTemplate
        ? this.approvalChainTemplate.client
        : {};
    }
  }
};
</script>

<style lang="scss" scope></style>
